import Component from '@glimmer/component';

export default class WizardStepNoteComponent extends Component {
  <template>
    <div class="c-wizard-step__note" ...attributes>{{yield}}</div>
  </template>
}
